import { render, staticRenderFns } from "./col.vue?vue&type=template&id=34be9e3c"
import script from "./col.vue?vue&type=script&lang=js"
export * from "./col.vue?vue&type=script&lang=js"
import style0 from "./col.vue?vue&type=style&index=0&id=34be9e3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports